// extracted by mini-css-extract-plugin
export var cardIcon = "_1f-5";
export var cardIconUnframed = "_1f-9";
export var checkboxCard = "_1f-0";
export var checkboxCardSelected = "_1f-4";
export var disabled = "_1f-2";
export var interactive = "_1f-1";
export var outerBorder = "_1f-3";
export var spacerMedium = "_1f-8";
export var spacerSmall = "_1f-7";
export var spacerXsmall = "_1f-6";